import React from 'react'

interface DashboardEditIconProps {
	width?: number | string
	height?: number | string
	color?: string
	hovered?: boolean
	className?: string
}

const DashboardEditIcon: React.FC<DashboardEditIconProps> = ({
	width = 24,
	height = 24,
	color = '#5222D0',
	hovered,
	className,
}) => (
	<svg
		width={width}
		height={height}
		viewBox='0 0 24 24'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
		className={className}
	>
		<g clipPath='url(#clip0)'>
			<rect
				x='3'
				y='3'
				width='7'
				height='7'
				rx='2'
				stroke={hovered ? 'white' : color}
				strokeWidth='2'
			/>
			<rect
				x='14'
				y='14'
				width='7'
				height='7'
				rx='2'
				stroke={hovered ? 'white' : color}
				strokeWidth='2'
			/>
			<rect
				x='3'
				y='14'
				width='7'
				height='7'
				rx='2'
				stroke={hovered ? 'white' : color}
				strokeWidth='2'
			/>
			<g clipPath='url(#clip1)'>
				<path
					d='M17.5 2.836V10.169M21.166 6.503H13.833'
					stroke={hovered ? 'white' : color}
					strokeWidth='2'
					strokeLinecap='round'
				/>
			</g>
		</g>
		<defs>
			<clipPath id='clip0'>
				<rect width='24' height='24' fill='white' />
			</clipPath>
			<clipPath id='clip1'>
				<rect width='11' height='11' fill='white' transform='translate(12 1)' />
			</clipPath>
		</defs>
	</svg>
)

export default DashboardEditIcon
